export enum ProcessMethod {
  CheckEft = 1,
  Ach = 2,
}

export enum ProcessMethodDescription {
  CheckEft = 'Check / EFT',
  Ach = 'ACH',
}
